import React from 'react';
import { Box, styled } from '@material-ui/core';

import { LanguageSelector } from '@/pages/Onboarding/components/LanguageSelector/LanguageSelector';

import DaylightLogo from '@/assets/Daylight_logo_default.svg';
import SleepioLogo from '@/assets/SleepioLogoIcon.svg';

interface SpringHealthHeaderProps {
  product: string;
}

const HeaderBar = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  marginTop: 44,
  paddingBottom: 16,
  borderBottom: '1px solid #DFE1E6',
});

const Logo = styled('img')({
  height: 32,
});

const PRODUCT_LOGOS: Record<string, { src: string; alt: string }> = {
  daylight: { src: DaylightLogo, alt: 'Daylight' },
  sleepio: { src: SleepioLogo, alt: 'Sleepio' },
};

const SpringHealthHeader: React.FC<SpringHealthHeaderProps> = ({ product }) => {
  const logo = PRODUCT_LOGOS[product];

  return (
    <HeaderBar>
      {logo && <Logo src={logo.src} alt={logo.alt} />}
      <LanguageSelector iconOnly />
    </HeaderBar>
  );
};

export default SpringHealthHeader;
